angular.module('gym.bulkMessages').controller('confirmBulkMessageCtrl', ["$scope", "$rootScope", "$state", "$stateParams", "$location", "$modal", "$filter", "bulkMessageService", "ConfirmBulkMessageService", "ngTableParams", "EmploymentService", "Events", "flash", "loadingAnimation", function($scope, $rootScope, $state, $stateParams, $location, $modal, $filter, bulkMessageService, ConfirmBulkMessageService, ngTableParams, EmploymentService, Events, flash, loadingAnimation) {
  var bulkMessage, displayBlockAccessMessage, hasSelectedRecipients, params, ref;
  $scope.permissions = EmploymentService.get().permissions;
  $scope.stateParams = $stateParams;
  $scope.bulkMessage = bulkMessage = bulkMessageService.get();
  $scope.pluralMessageType = function() {
    return bulkMessageService.pluralMessageType($scope.bulkMessage.template.channel, $scope.bulkMessage.recipientList);
  };
  if (!((ref = bulkMessage.recipientList) != null ? ref.length : void 0) || !bulkMessage.template) {
    params = {
      notice: $location.search().notice
    };
    $state.go('gym.bulkMessages.new', params);
  }
  if ($stateParams.eventId) {
    Events.get($stateParams.eventId).then(function(event) {
      return $scope.eventData = event;
    });
  }
  displayBlockAccessMessage = function() {
    return $modal.open({
      template: require('templates/gyms/bulk_messages/access_blocked_modal.html.slim'),
      controller: ["$scope", "$state", "$modalInstance", function($scope, $state, $modalInstance) {
        $scope.isPayor = window.currentUser.account_owner;
        return $scope.close = function() {
          $state.go('gym.bulkMessages.new');
          return $modalInstance.dismiss('cancel');
        };
      }]
    });
  };
  if (!$rootScope.gym.has_subscription) {
    displayBlockAccessMessage();
  }
  hasSelectedRecipients = function() {
    return !!_.findWhere($scope.bulkMessage.recipientList, {
      selected: true
    });
  };
  $scope.isReady = function() {
    return $rootScope.gym.has_subscription && hasSelectedRecipients();
  };
  return $scope.create = function() {
    if (!$scope.isReady()) {
      return;
    }
    return ConfirmBulkMessageService.confirm(bulkMessage, $rootScope.gym).then(function() {
      var source;
      loadingAnimation.show();
      source = (function() {
        switch ($stateParams.from) {
          case 'absent_attendances':
            return 'absent_attendees';
          case 'bulk_mobile_app_changes':
          case 'invoices':
          case 'contactInvoices':
            return void 0;
          default:
            if ($stateParams.eventId) {
              return 'event_attendee_list';
            } else {
              return 'bulk_messages';
            }
        }
      })();
      params = {
        event_id: +$stateParams.eventId,
        invoice_id: $stateParams.invoiceId,
        source: source
      };
      return bulkMessageService.create(bulkMessage, params).then(function() {
        var redirectState, redirectStateParams;
        bulkMessageService.clear();
        redirectState = (function() {
          switch ($stateParams.from) {
            case 'absent_attendances':
              return 'gym.dashboard_reports.absent_attendances';
            case 'bulk_mobile_app_changes':
              return 'gym.reports.bulk_mobile_app_changes';
            case 'invoices':
              return 'gym.invoices';
            case 'contactInvoices':
              return 'gym.contacts.edit';
            default:
              return 'gym.bulkMessages.new';
          }
        })();
        redirectStateParams = (function() {
          switch ($stateParams.from) {
            case 'contactInvoices':
              return {
                contactId: +$stateParams.fromContactId,
                contactType: $stateParams.fromContactType,
                tab: 'payments'
              };
            default:
              return {};
          }
        })();
        $state.go(redirectState, redirectStateParams);
        return flash.success = 'Messages were sent successfully';
      }, function() {
        flash.error = 'Sorry, the messages could not be sent';
        return loadingAnimation.hide();
      });
    });
  };
}]);
